
import { computed, defineComponent, reactive, ref, toRaw, toRefs, watch, inject, PropType } from "vue";
import StaffComponent from "./Staff.vue";
import Customer from "./Customer.vue";
import Factory from "./Factory.vue";
import { Toast } from "vant";
export type UserInfo = {
  id: string;
  head_pic: string;
  name: string;
  department_name: string;
  duty_name: string;
};
export default defineComponent({
  name: "ChooseEventPerson",
  components: {
    Staff: StaffComponent,
    Customer,
    Factory
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    ids: {
      type: Object as PropType<{ factory_ids: string; stores_ids: string; user_ids: string }>,
      default: () => {
        return { factory_ids: "", stores_ids: "", user_ids: "" };
      }
    }
  },
  emits: ["confirm", "update:show"],
  setup(props, { emit }) {
    const isComponentType = inject("isComponentType");
    const { show, multiple } = toRefs(props);
    const popupShow = computed({
      get() {
        return show.value;
      },
      set(value) {
        emit("update:show", value);
      }
    });
    const state = reactive<Dictionary<UserInfo[]>>({
      staff: [],
      customer: [],
      factory: []
    });
    watch(
      () => state.staff,
      now => {
        if (multiple.value || now.length == 0) return;
        state.customer = [];
        state.factory = [];
      }
    );
    watch(
      () => state.customer,
      now => {
        if (multiple.value || now.length == 0) return;
        state.staff = [];
        state.factory = [];
      }
    );
    watch(
      () => state.factory,
      now => {
        if (multiple.value || now.length == 0) return;
        state.staff = [];
        state.customer = [];
      }
    );

    const value = ref("");
    const active = ref("staff");
    const confirm = () => {
      const user_ids = Object.values(toRaw(state)).flat();
      if (user_ids.length === 0) return Toast.fail("请选择人员");
      popupShow.value = false;
      emit("confirm", toRaw(state), user_ids.map(item => item.id).join(","));
    };

    return {
      value,
      popupShow,
      active,
      confirm,
      state,
      isComponentType
    };
  }
});
